import Image, { StaticImageData } from 'next/image'
// import { ButtonLink } from './ButtonLink'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'

interface Feature {
  name?: string
  heading: string
  description: string
  link?: string
  image: StaticImageData
}

interface PrimaryFeaturesProps {
  features: Feature[]
  gradientBg?: 'top' | 'bottom' | 'none'
  reverse?: boolean
  mainFeature?: boolean
}

export default function FeaturesList({
  features,
  gradientBg = 'none',
  reverse,
  mainFeature,
}: PrimaryFeaturesProps) {
  return (
    <section
      className={`relative flex w-full flex-col items-center px-5 py-20 sm:px-10 xl:px-[100px] xl:py-[112px] ${
        gradientBg === 'top'
          ? 'bg-cost-linear'
          : gradientBg === 'bottom'
          ? 'bg-cost-linear-v2'
          : ''
      }`}
    >
      <div className="flex w-full flex-col items-center gap-40 xl:mt-0 xl:gap-[224px]">
        {features.map((feature, index) => (
          <div
            key={feature.heading}
            className={`flex ${
              reverse
                ? index % 2 !== 0
                  ? 'flex-col-reverse xl:flex-row'
                  : 'flex-col-reverse xl:flex-row-reverse'
                : index % 2 !== 0
                ? 'flex-col-reverse xl:flex-row-reverse'
                : 'flex-col-reverse xl:flex-row'
            } w-full max-w-[1240px] items-center justify-between gap-10 xl:gap-20`}
          >
            <Image
              src={feature.image}
              alt={feature.heading}
              className="w-full max-w-[580px]"
            />

            <div className="flex w-full flex-col items-start justify-center px-0 xl:w-[580px] xl:px-[60px]">
              {mainFeature && (
                <h5 className="font-robotoMono text-xs font-medium uppercase leading-[100%] tracking-[1.2px] text-[#38BDF9]">
                  {feature.name}
                </h5>
              )}
              <h3 className="mt-4 w-full text-[26px] font-medium leading-[130%] tracking-[-0.26px] lg:w-[467px] xl:text-[36px] xl:tracking-[-0.36px]">
                {feature.heading}
              </h3>
              <p className="mt-4 w-full text-base !leading-[150%] tracking-[-0.16px] text-white/80 lg:w-[457px] xl:mt-5">
                {feature.description}
              </p>

              {mainFeature && (
                <Link
                  href={feature.link ?? '#'}
                  className="group mt-4 flex max-w-max items-center gap-2.5 pt-4"
                >
                  <span className="text-base text-[#38BDF9] transition-colors duration-300 group-hover:text-white">
                    Learn More
                  </span>
                  <ChevronRightIcon className="-ml-1 h-3 w-3 stroke-2 text-[#38BDF9] transition-colors duration-300 group-hover:text-white" />
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
